// When Splide is used to create a carousel, it clones the slides to create an infinite loop effect (see game-server-hosting pages for example). However, this can cause accessibility issues because the cloned slides contain H3 headings that are duplicated in the DOM. This script converts the headings in the cloned slides to divs, and sets them as hidden and inert, preventing them from being announced by screen readers.

// Pass { keepInteractive: true } for a slider whose clones can sit in view (e.g. autoWidth loops): their headings are still demoted, but Splide's own aria-hidden/tabindex handling decides whether they can be reached, so a visible clone stays clickable.

"use strict";

window.demoteSplideCloneHeadings = function (
	rootSelector,
	{ keepInteractive = false } = {}
) {
	const root = document.querySelector(rootSelector);
	if (!root) return;

	root.querySelectorAll(".splide__slide--clone").forEach((clone) => {
		if (!keepInteractive) {
			clone.setAttribute("aria-hidden", "true");
			clone.setAttribute("inert", "");
		}

		clone.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach((heading) => {
			const replacement = document.createElement("div");
			replacement.className = heading.className;
			replacement.innerHTML = heading.innerHTML;
			heading.replaceWith(replacement);
		});
	});
};
